module.exports = __webpack_public_path__ + "img/epr_small@2x.55e5429c.jpg";